// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"f8-z","button":"g8-z","disabled":"h8-z","creditCard":"i8-z","wrapper":"j8-z"};